import React from 'react'
import { Box, Typography } from '@mui/material'
import { advancedColors } from '../theme'
import { InstanceAnswer } from './questionnaireHistory'

type Props = { answers: InstanceAnswer[] }

const AnswerList = ({ answers }: Props) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 1 }}>
    {answers.map((answer) => (
      <Box key={answer.id}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {answer.question}
        </Typography>
        <Typography variant="body2" sx={{ color: advancedColors.inkMuted }}>
          {answer.answer}
        </Typography>
      </Box>
    ))}
  </Box>
)

export default AnswerList
